import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { Ladder } from '../components/Ladder';

export const LadderProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <Ladder {...data} />
        </Provider>
    );
};

export default LadderProvider;

LadderProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
